export default "__VITE_ASSET__C_n0QePg__"